import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_2 = { class: "svg-icon svg-icon-1" }
const _hoisted_3 = { class: "mb-5 fv-row" }
const _hoisted_4 = { class: "fv-plugins-message-container" }
const _hoisted_5 = { class: "fv-help-block" }
const _hoisted_6 = {
  key: 0,
  class: "text-success"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_VeeForm = _resolveComponent("VeeForm")!
  const _component_b_modal = _resolveComponent("b-modal")!

  return (_openBlock(), _createBlock(_component_b_modal, {
    hideFooter: "",
    noCloseOnBackdrop: "",
    id: "auth-code-modal",
    ref: "modalElement",
    dialogClass: "mw-650px index-modal",
    "header-class": "pb-0 border-0 justify-content-end mb-5",
    bodyClass: "text-center scroll-y mx-5 mx-xl-18 pt-0 pb-15",
    modelValue: _ctx.authModalVisible,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.authModalVisible) = $event)),
    onShow: _ctx.onShow,
    onHide: _ctx.onHide,
    onCancel: _ctx.onHide
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, [
          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
        ])
      ])
    ]),
    default: _withCtx(() => [
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "mb-13" }, [
        _createElementVNode("h1", { class: "mb-3" }, "Verify your action"),
        _createElementVNode("div", { class: "text-gray-400 fw-bold fs-5" }, " Enter code from your Two-Factor Auth application ")
      ], -1)),
      _createVNode(_component_VeeForm, {
        id: "kt_modal_create_bank_account_form",
        class: "form",
        ref: "formElement",
        "validation-schema": _ctx.validationSchema
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _cache[3] || (_cache[3] = _createElementVNode("label", { class: "required fs-5 fw-bold mb-2" }, "Auth Code", -1)),
            _createVNode(_component_Field, {
              type: "text",
              class: "form-control form-control-solid",
              placeholder: "Auth Code...",
              name: "auth_code",
              id: "auth_code",
              maxlength: "6",
              modelValue: _ctx.tfaCode,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tfaCode) = $event)),
              validateOnBlur: false,
              "model-value": _ctx.$store.getters.tfa_code,
              disabled: _ctx.$store.getters.is_tfa_submitting
            }, null, 8, ["modelValue", "model-value", "disabled"]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                (_ctx.$store.getters.is_tfa_submitting && 'on')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Code accepted. Verification process..."))
                  : (_openBlock(), _createBlock(_component_ErrorMessage, {
                      key: 1,
                      name: "auth_code"
                    }))
              ])
            ])
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-danger",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.authModalVisible = false))
          }, " Cancel ")
        ]),
        _: 1
      }, 8, ["validation-schema"])
    ]),
    _: 1
  }, 8, ["modelValue", "onShow", "onHide", "onCancel"]))
}